const create = (e, f, handler) => (empty = e, format = f) => (rule, value, callback) => {
  if (value === '') {
    if (rule.required) callback(new Error(empty));
  } else {
    if (
      handler(value)
    ) {
      callback()
    } else {
      callback(new Error(format));
    }
  }
}

export const idNumberValidator = create("请输入身份证号", "请输入有效的身份证号", (value) => (/^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(value)))

export const phoneValidator = create("请输入电话号码", "请输入正确格式的电话号码", (value) => {
  return (
    /^(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14}$/.test(value) ||
    /^1[3-9]\d{9}$/.test(value)
  )
})

export const dateValidator = create("请输入日期", "请输入有效日期", (value) => {
  return /^((([0-9]{2})(0[48]|[2468][048]|[13579][26]))|((0[48]|[2468][048]|[13579][26])00)-02-29)|([0-9]{3}[1-9]|[0-9]{2}[1-9][0-9]{1}|[0-9]{1}[1-9][0-9]{2}|[1-9][0-9]{3})-(((0[13578]|1[02])-(0[1-9]|[12][0-9]|3[01]))|((0[469]|11)-(0[1-9]|[12][0-9]|30))|(02-(0[1-9]|[1][0-9]|2[0-8])))$/.test(value)
})

export const geometryValidator = (empty) => (rule , value , callback) => {
  if (rule.required){
    if(value.type && value.coordinates){
      callback()
    }else{
       callback(new Error(empty))
    }
  }else{
    callback()
  }
}

export const emptyValidator = (empty = "请选择", type = 'string') => (rule, value, callback) => {
  if (type == 'string') {
    if (value === '') {
      if (rule.required) callback(new Error(empty));
    } else {
      callback()
    }
  } else if (type == 'array') {
    if (value.length == 0) {
      if (rule.required) callback(new Error(empty));
    } else {
      callback()
    }
  }

}

export const bankCardValidator = create("请输入银行卡号", "请输入正确格式的银行卡号", (value) => {
  return /^([1-9]{1})(\d{14}|\d{18})$/.test(value)
})
